import { useState, useEffect } from "react";

export default function ConsentBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("consentAccepted");
    if (!accepted) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("consentAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-yellow-400 dark:bg-blue-800 text-blue-900 dark:text-yellow-400 shadow-lg px-6 py-4 flex flex-col md:flex-row items-center justify-between gap-4 z-50">
      <p className="text-sm md:text-base font-medium text-center md:text-left">
        We use cookies and analytics to improve your experience. By continuing, 
        you agree to our{" "}
        <a
          href="/privacy-policy"
          className="underline hover:text-blue-700 dark:hover:text-yellow-200"
        >
          Privacy Policy
        </a>{" "}
        and{" "}
        <a
          href="/terms"
          className="underline hover:text-blue-700 dark:hover:text-yellow-200"
        >
          Terms & Conditions
        </a>
        .
      </p>
      <button
        onClick={handleAccept}
        className="px-5 py-2 bg-blue-900 dark:bg-yellow-400 text-yellow-400 dark:text-blue-900 font-semibold rounded-lg shadow hover:scale-105 transition"
      >
        Accept
      </button>
    </div>
  );
}
